/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text, type TextProps } from '@lib/canvasx/components/Text';
import AhaIconGlyphs, { type AhaIcons } from '../AhaIconGlyphs';

export interface AhaIconProps extends Partial<Exclude<TextProps, 'face'>> {
  icon: AhaIcons;
}

export const AhaIcon: CanvaSXFC<AhaIconProps> = function ({ icon, ...props }) {
  const glyph = AhaIconGlyphs[icon];

  return (
    <Text face='aha-icon' {...props}>
      {String.fromCharCode(glyph)}
    </Text>
  );
};
